/** 江西维保报告管理路由。 */
export default {
  path: 'report',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'jxxfWbReportIndex',
      component: () => import('@/features/jxxf/wb/report/reportList.vue'),
      meta: {
        navtabTitle: '维保报告管理',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};
